import { toast } from 'react-toastify';

import { XCircle } from '@phosphor-icons/react';

const NotificationError = (message: string) => {
  toast.error(message, {
    icon: () => <XCircle size={24} color='#FF3B30' />,
  });
};

export default NotificationError;
